import vistaPreviaImg from '../../../../assets/factura/vistaPreviaFactura.jpg'
import './FacturaPDFStyles.css'

const formatCLP = (v = 0) =>
  Number(v || 0).toLocaleString('es-CL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })

const calculateTotals = doc => {
  const lines = doc?.details || []
  const subtotal = lines.reduce((acc, d) => {
    const qty = Number(d.quantity) || 0
    const price = Number(d.unit_price) || 0
    const pct = Number(d.discount_percent) || 0
    const bruto = qty * price
    const desc = (bruto * pct) / 100
    return acc + (bruto - desc)
  }, 0)

  // Para Notas de Crédito, chequeamos la referencia para ver si es exenta
  const isExenta = doc?.references?.[0]?.dte_type_code === '34'
  const ivaRate = isExenta ? 0 : 0.19
  const iva = Math.round(subtotal * ivaRate)
  const total = subtotal + iva

  return { subtotal, iva, total, isExenta }
}

const NotaCreditoPreviewPDF = ({ document, currentBusiness, printRef }) => {
  const issuer = document?.document_issuer || {}
  const receiver = document?.document_receiver || {}
  const dteCode = String(document?.dte_type?.code || '')
  const { subtotal, iva, total, isExenta } = calculateTotals(document)

  let tituloFactura = 'FACTURA ELECTRÓNICA'
  if (dteCode === '34') tituloFactura = 'FACTURA ELECTRÓNICA EXENTA'
  if (dteCode === '61') tituloFactura = 'NOTA DE CRÉDITO ELECTRÓNICA'

  const fecha = document?.date_issued || ''
  const comunaSii = issuer.district || issuer.city || ''

  return (
    <div
      className='pdf-preview-wrapper'
      style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >

      <div ref={printRef} className='factura-pdf-container'>
        {/* MARCA DE AGUA */}
        <div className='factura-watermark'>{'Documento\nNO\nValido'}</div>

        {/* Encabezado */}
        <div className='factura-header'>
          <div className='factura-emitter'>
            <div className='factura-emitter-name'>
              {(issuer.business_name || currentBusiness?.business_name || '').toUpperCase()}
            </div>
            {issuer.business_activity && (
              <div className='factura-emitter-info'>GIRO: {issuer.business_activity}</div>
            )}
            {(issuer.address || issuer.district || issuer.city) && (
              <div className='factura-emitter-info'>
                {issuer.address || ''}
                {issuer.district ? ` - ${issuer.district}` : ''}
                {issuer.city ? ` - ${issuer.city}` : ''}
              </div>
            )}
            {issuer.email && <div className='factura-emitter-info'>E-MAIL: {issuer.email}</div>}
            {issuer.phone_number && (
              <div className='factura-emitter-info'>Teléfono: {issuer.phone_number}</div>
            )}
          </div>

          <div className='factura-legal-box'>
            <div className='factura-rut'>R.U.T.: {issuer.rut || currentBusiness?.rut || ''}</div>
            <div className='factura-title'>{tituloFactura}</div>
            <div className='factura-folio'>FOLIO {document?.folio || 'NO ASIGNADO'}</div>
          </div>
        </div>

        {/* Receptor + Fecha */}
        <div className='factura-receiver-section'>
          <div className='factura-receiver-box'>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>SEÑOR(ES):</span>
              <span>{receiver.business_name || ''}</span>
            </div>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>R.U.T.:</span>
              <span>{receiver.rut || ''}</span>
            </div>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>GIRO:</span>
              <span>{receiver.business_activity || ''}</span>
            </div>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>DIRECCIÓN:</span>
              <span>{receiver.address || ''}</span>
            </div>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>COMUNA:</span>
              <span>{receiver.district || ''}</span>
            </div>
            <div className='factura-receiver-row'>
              <span className='factura-receiver-label'>CIUDAD:</span>
              <span>{receiver.city || ''}</span>
            </div>
          </div>

          <div className='factura-date-box'>
            <div className='factura-sii-office'>
              S.I.I. {comunaSii ? `- ${comunaSii.toUpperCase()}` : ''}
            </div>
            <div className='factura-date-row'>
              <span className='factura-date-label'>Fecha Emisión:</span>
              <span className='bold'>{fecha}</span>
            </div>
          </div>
        </div>

        {/* TABLA REFERENCIAS (Solo si existen) */}
        {document?.references && document.references.length > 0 && (
          <table className='factura-table' style={{ marginBottom: '10px' }}>
            <thead>
              <tr>
                <th style={{ backgroundColor: '#f0f0f0' }}>Tipo Doc</th>
                <th style={{ backgroundColor: '#f0f0f0' }}>Folio</th>
                <th style={{ backgroundColor: '#f0f0f0' }}>Fecha Ref.</th>
                <th style={{ backgroundColor: '#f0f0f0' }}>Razón Referencia</th>
              </tr>
            </thead>
            <tbody>
              {document.references.map((item, i) => {
                const docTypeStr =
                  item.dte_type_code === '33'
                    ? 'Factura'
                    : item.dte_type_code === '34'
                      ? 'Factura Exenta'
                      : item.dte_type_code
                return (
                  <tr key={i}>
                    <td style={{ textAlign: 'center' }}>{docTypeStr}</td>
                    <td style={{ textAlign: 'center' }}>{item.reference_folio || ''}</td>
                    <td style={{ textAlign: 'center' }}>
                      {item.reference_date ? item.reference_date.slice(0, 10) : ''}
                    </td>
                    <td style={{ paddingLeft: '5px' }}>{item.reference_reason || ''}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}

        {/* Tabla detalles */}
        <table className='factura-table'>
          <thead>
            <tr>
              <th style={{ width: '12%' }}>Código</th>
              <th style={{ width: '40%' }}>Descripción</th>
              <th style={{ width: '10%' }}>Cantidad</th>
              <th style={{ width: '12%' }}>Precio</th>
              <th style={{ width: '10%' }}>%Impto Adic.*</th>
              <th style={{ width: '8%' }}>%Desc.</th>
              <th style={{ width: '8%' }}>Valor</th>
            </tr>
          </thead>
          <tbody>
            {(document?.details || []).map((d, idx) => {
              const qty = Number(d.quantity) || 0
              const price = Number(d.unit_price) || 0
              const pct = Number(d.discount_percent) || 0
              const bruto = qty * price
              const desc = (bruto * pct) / 100
              const neto = bruto - desc
              const additionalTaxPct = d.additional_tax_percent || d.additional_tax || 0

              return (
                <tr key={idx}>
                  <td style={{ textAlign: 'center' }}>{d.item_code || ''}</td>
                  <td>{d.item_name || ''}</td>
                  <td style={{ textAlign: 'right' }}>{qty || ''}</td>
                  <td style={{ textAlign: 'right' }}>{price ? formatCLP(price) : ''}</td>
                  <td style={{ textAlign: 'right' }}>
                    {additionalTaxPct ? `${additionalTaxPct}%` : ''}
                  </td>
                  <td style={{ textAlign: 'right' }}>{pct ? `${pct}%` : ''}</td>
                  <td style={{ textAlign: 'right' }}>{neto ? formatCLP(neto) : ''}</td>
                </tr>
              )
            })}
          </tbody>
        </table>

        {/* Footer */}
        <div className='factura-footer'>
          <div className='factura-stamp'>
            <img className='factura-stamp-img' src={vistaPreviaImg} alt='VISTAPREVIA' />
            <div className='factura-stamp-text'>Timbre Electrónico SII — www.sii.cl</div>
            <div className='factura-stamp-text'>
              Res. 99 de 2014 Verifique documento: www.sii.cl
            </div>
          </div>

          <div className='factura-totals-table'>
            <div className='factura-total-row'>
              <div className='factura-total-label'>MONTO EXENTO</div>
              <div className='factura-total-currency'>$</div>
              <div className='factura-total-value'>{formatCLP(subtotal)}</div>
            </div>
            <div className='factura-total-row'>
              <div className='factura-total-label'>I.V.A. {isExenta ? '0%' : '19%'}</div>
              <div className='factura-total-currency'>$</div>
              <div className='factura-total-value'>{formatCLP(iva)}</div>
            </div>
            <div className='factura-total-row'>
              <div className='factura-total-label'>IMPUESTO ADICIONAL</div>
              <div className='factura-total-currency'>$</div>
              <div className='factura-total-value'>0</div>
            </div>
            <div className='factura-total-row bold'>
              <div className='factura-total-label'>TOTAL</div>
              <div className='factura-total-currency'>$</div>
              <div className='factura-total-value'>{formatCLP(total)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotaCreditoPreviewPDF
